import React from 'react'
import PropTypes from 'prop-types'
import { InputGroup } from 'react-bootstrap'

const FormInputGroup3 = (props) => {
  return (
    <InputGroup
      className={props.className}
    >
      {props.children}
    </InputGroup>
  )
}

FormInputGroup3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

FormInputGroup3.defaultProps = {
  className: ''
}

export default FormInputGroup3
